var Lib = require('./src/svg-icon');

exports.SVGIcon = Lib.SVGIcon;
exports.SVGMarker = Lib.SVGMarker;
